import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { FileUpload } from "primereact/fileupload";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";


interface IVideo {
    id: number;
    videoFileName: string;
    order?: number;
}

interface IProps {
    visible: boolean;
    onHide: () => void;
    video: IVideo[];
    title?: string;
    toast: any;
    spotId: number;
    reload: () => void;
}

export const SpotVideo = (props: IProps) => {
    const [uploading, setUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [localImages, setLocalImages] = useState<IVideo[]>([]);
    const fileUploadRef = useRef<FileUpload>(null);
    const [isOrderChanged, setIsOrderChanged] = useState(false);
    const [videos, setVideos] = useState<IVideo[]>([]);


    useEffect(() => {
        const sorted = [...props.video].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        setLocalImages(props.video);
        setIsOrderChanged(false);
    }, [props.video]);



    // Delete existing image
    const handleDelete = async (id: number) => {
        const response = await Fetch(`City/DeleteImage/${id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", detail: "Image deleted", life: 3000 });
            props.reload();
        }
    };

    // When user selects new images
    const onSelectFiles = (event: any) => {
        const files = event.files as File[];
        setSelectedFiles((prev) => [...prev, ...files]);
    };

    const handleSave = async () => {
        if (selectedFiles.length === 0) {
            props.toast.current.show({ severity: "warn", detail: "No video selected", life: 3000 });
            return;
        }

        setUploading(true);
        for (const file of selectedFiles) {
            const formData = new FormData();
            formData.append("video", file);
            formData.append("spotId", props.spotId.toString());

            const response = await Fetch("city/addVideo", "POST", formData, null, props.toast);
            if (response) {
                setUploading(false);
                props.toast.current.show({ severity: "success", detail: "Video uploaded successfully", life: 3000 });
                setSelectedFiles([]);
                fileUploadRef.current?.clear();
                props.reload();
            }
            setUploading(false);
            setSelectedFiles([]);
            fileUploadRef.current?.clear();
            props.reload();
        }

    };

    return (
        <Dialog visible={props.visible} header={
            <span className="text-blue-700 font-semibold text-lg">
                Upload Video for {props.title}
            </span>
        } style={{ width: "60vw" }} onHide={props.onHide} >

            <div className="card p-4 mb-4 shadow-sm border-1">
                <div className="flex align-items-center justify-content-between gap-3 flex-wrap">
                    <FileUpload ref={fileUploadRef} mode="basic" name="file" accept="video/*"
                        multiple customUpload uploadHandler={() => { }} onSelect={onSelectFiles} chooseLabel="Choose Video" className="flex-1" />
                    <Button label={uploading ? "Saving..." : "Save"} icon="" loading={uploading} onClick={handleSave} />
                </div>
            </div>

            {/* Display uploaded videos */}
            <div className="grid">
                {props.video.length > 0 ? (
                    props.video.map((v: any) => (
                        <div key={v.id} className="col-12 md:col-6 lg:col-4 p-2">
                            <video width="100%" height="200" controls className="rounded-lg shadow-sm border">
                                <source src={`${baseUrl}city/streamVideo?fileName=${v.videoFileName}`} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    ))
                ) : (
                    <p className="text-gray-500">No videos uploaded yet.</p>
                )}
            </div>

        </Dialog>
    );
};
